const footerNYFieldsSelector = ['fields.footer'].join(',')

export default footerNYFieldsSelector
